<!--首页-->
<template>
    <div>
        <van-search
                v-model="params.keywords"
                placeholder="请输入搜索关键词"
                show-action
                shape="round"
                @keyup="onChange"
                @search="onSearch"

        >
            <div slot="action" @click="onSearch">搜索</div>
        </van-search>
        <van-pull-refresh v-model="loadingFresh" @refresh="onRefresh">
            <van-list
                    v-model="loadingMore"
                    :finished="noMore"
                    finished-text="没有更多了"
                    @load="onLoad"
            >
                <div style="padding-top: 15px;"></div>
                <div v-if="!params.keywords" class="search-tip">
                    <div class="search-tip-title">热门搜索</div>
                    <div class="search-tip-wrap">
                        <div v-for="(item,index) in keywordsList" @click="onSelect(item)">{{item}}</div>
                    </div>
                </div>

                <div v-if="params.keywords">
                    <GoodsItems :goodsList="list"></GoodsItems>
                </div>

                <!--<div v-if="noMore" class="search-tip" >
                    暂无数据
                </div>-->
            </van-list>
        </van-pull-refresh>
    </div>
</template>
<style scoped>
    .van-search--show-action {
        background: #f2f2f2 !important;
    }

    .search-tip {
        padding: 0 10px;
        font-size: 14px;
        line-height: 28px;

    }

    .search-tip .search-tip-title {
        color: #999
    }

    .search-tip .search-tip-wrap {
        display: flex;
        flex-wrap: wrap;
    }

    .search-tip .search-tip-wrap div {
        color: #666;
        display: flex;
        width: 50%;
    }

</style>

<script>
    import GoodsItems from '@/components/GoodsItem1.vue';
    import {
        Search, PullRefresh, List,
    } from 'vant';

    export default {
        name: 'Search',
        components: {
            Search,
            GoodsItems,
            [PullRefresh.name]: PullRefresh,
            [List.name]: List,
        },
        data: function () {
            return {
                loadingFresh: false,
                loadingMore: false,
                noMore: true,
                params: {
                    p: 1,
                    step: 5,
                    keywords: '',
                },
                list: [],
                keywordsList: [],
                homeTop : 0,

            }
        },
        filter: {},
        activated() {
            let that = this;

            if (!this.$route.meta.isBack) {
                // 清空查询条件和数据
                that.list = [];
                that.params.p = 1;
                that.params.keywords = '';
                that.loadingMore = false;
                that.noMore = true;
            }
            this.$route.meta.isBack = false;

            document.getElementById('app').scrollTop = this.homeTop || 0
        },
        mounted() {
            document.title = '搜索';
            this.getKeywords()
        },
        destroyed() {
        },
        beforeRouteEnter(to, from, next) {
            if (from.path == "/goodsdetail" || from.path == "/shopgoodsdetail") {
                to.meta.isBack = true;
            } else {
                to.meta.isBack = false;
            }
            next();
        },
        methods: {
            // 获取热门搜索词语
            getKeywords() {
                let that = this;
                this.$api.get('/api/goods/searchKeywords', that.params, (res) => {
                    // console.log(res)
                    that.keywordsList = res.data;
                })
            },

            fetch() {
                let that = this;
                that.loadingMore = true;
                this.$api.get('/api/goods/goodsSearch', that.params, (res) => {
                    that.loadingMore = false;

                    if (res.data.currentpage == 1) {
                        that.list = res.data.list
                        that.loadingFresh = false
                        // console.log(1)
                    } else {
                        let list = that.list.concat(res.data.list);
                        that.list = list
                    }
                    if (res.data.list.length == 0) {
                        that.noMore = true
                    }

                    this.params.p += 1;



                })
            },

            getFetchCommon() {
                let that = this;
                that.params.p = 1;
                that.list = [];
                that.noMore = false;

                if (this.params.keywords) {
                    that.fetch();
                } else {
                    that.noMore = true;
                }
            },

            onChange() {
                let that = this;
                if (!this.params.keywords) {
                    that.noMore = true;
                }
                that.getFetchCommon()
            },

            onSearch() {
                let that = this;
                that.getFetchCommon()
            },

            onSelect(keyword) {
                let that = this;
                that.params.keywords = keyword
                that.getFetchCommon()

            },

            onLoad() {
                if (this.params.p > 1 && this.params.keywords) {

                    setTimeout(() => {
                        this.fetch()
                    }, 500);

                }

            },

            onRefresh() {
                let that = this;
                that.params.p = 1;
                that.noMore = false;
                if (!that.params.keywords) {
                    that.noMore = true;
                }
                that.fetch();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Search.vue?14769b94